/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BulkEditRequestBulkEditChangeArtistsArtistChangeInner } from './BulkEditRequestBulkEditChangeArtistsArtistChangeInner';
import {
    BulkEditRequestBulkEditChangeArtistsArtistChangeInnerFromJSON,
    BulkEditRequestBulkEditChangeArtistsArtistChangeInnerFromJSONTyped,
    BulkEditRequestBulkEditChangeArtistsArtistChangeInnerToJSON,
} from './BulkEditRequestBulkEditChangeArtistsArtistChangeInner';
import type { BulkEditRequestBulkEditChangeArtistsArtistLinkInner } from './BulkEditRequestBulkEditChangeArtistsArtistLinkInner';
import {
    BulkEditRequestBulkEditChangeArtistsArtistLinkInnerFromJSON,
    BulkEditRequestBulkEditChangeArtistsArtistLinkInnerFromJSONTyped,
    BulkEditRequestBulkEditChangeArtistsArtistLinkInnerToJSON,
} from './BulkEditRequestBulkEditChangeArtistsArtistLinkInner';

/**
 * 
 * @export
 * @interface BulkEditRequestBulkEditChangeArtists
 */
export interface BulkEditRequestBulkEditChangeArtists {
    /**
     * 
     * @type {Array<BulkEditRequestBulkEditChangeArtistsArtistChangeInner>}
     * @memberof BulkEditRequestBulkEditChangeArtists
     */
    artistChange?: Array<BulkEditRequestBulkEditChangeArtistsArtistChangeInner>;
    /**
     * 
     * @type {Array<BulkEditRequestBulkEditChangeArtistsArtistLinkInner>}
     * @memberof BulkEditRequestBulkEditChangeArtists
     */
    artistLink?: Array<BulkEditRequestBulkEditChangeArtistsArtistLinkInner>;
}

/**
 * Check if a given object implements the BulkEditRequestBulkEditChangeArtists interface.
 */
export function instanceOfBulkEditRequestBulkEditChangeArtists(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BulkEditRequestBulkEditChangeArtistsFromJSON(json: any): BulkEditRequestBulkEditChangeArtists {
    return BulkEditRequestBulkEditChangeArtistsFromJSONTyped(json, false);
}

export function BulkEditRequestBulkEditChangeArtistsFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkEditRequestBulkEditChangeArtists {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'artistChange': !exists(json, 'artist_change') ? undefined : ((json['artist_change'] as Array<any>).map(BulkEditRequestBulkEditChangeArtistsArtistChangeInnerFromJSON)),
        'artistLink': !exists(json, 'artist_link') ? undefined : ((json['artist_link'] as Array<any>).map(BulkEditRequestBulkEditChangeArtistsArtistLinkInnerFromJSON)),
    };
}

export function BulkEditRequestBulkEditChangeArtistsToJSON(value?: BulkEditRequestBulkEditChangeArtists | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'artist_change': value.artistChange === undefined ? undefined : ((value.artistChange as Array<any>).map(BulkEditRequestBulkEditChangeArtistsArtistChangeInnerToJSON)),
        'artist_link': value.artistLink === undefined ? undefined : ((value.artistLink as Array<any>).map(BulkEditRequestBulkEditChangeArtistsArtistLinkInnerToJSON)),
    };
}

